import clsx from 'clsx';
import { isEmpty } from 'lodash-es';
import { h } from 'preact';
import { memo, Suspense } from 'preact/compat';
import { useEffect, useMemo, useState } from 'preact/hooks';

import { useSelector } from '@/redux/helper';

import MobileMapAccordion from '../../components/Map/MobileMapAccordion';
import ShareModal from '../../components/ShareModal/Modal';
import { useWindowResize } from '../../hooks';
import DesktopMap from './DesktopMap';
import MobileMap from './MobileMap';
import style from './style.scss';

const trailerInitialState = {
  show: false,
  data: null,
};

const MapView = ({ embed }) => {
  const allHabitats = useSelector((state) => state.allHabitats);
  const [filters, setFilters] = useState({});
  const { width } = useWindowResize();
  const isSmallScreen = useMemo(() => width < 678, [width]);
  const [trailer, setTrailer] = useState(trailerInitialState);

  const showTrailers = window.iframeContext?.showTrailers;
  const showCollapsed = window.iframeContext?.showCollapsed;

  const onShowTrailer = (data) =>
    setTrailer({
      show: true,
      data,
    });

  const habitats = useMemo(() => {
    let habitatsList = allHabitats;

    if (filters.partner) {
      habitatsList = habitatsList.filter(({ zoo: { _id } }) => _id === filters.partner);
    }

    if (!isEmpty(filters.habitats)) {
      habitatsList = habitatsList.filter(({ _id }) => filters.habitats.includes(_id));
    }

    if (!isEmpty(filters.disabledHabitats)) {
      habitatsList = habitatsList.filter(({ _id }) => !filters.disabledHabitats.includes(_id));
    }

    if (embed && isSmallScreen) {
      habitatsList = habitatsList.filter(({ isStreamOn }) => isStreamOn);
    }

    return habitatsList;
  }, [allHabitats, filters, embed, isSmallScreen]);

  const renderMobileMap = () => {
    if (showCollapsed) {
      return (
        <MobileMapAccordion showCollapsed>
          <MobileMap habitats={habitats} urlParams={filters} showTrailers={showTrailers} onShowTrailer={onShowTrailer} />
        </MobileMapAccordion>
      );
    }
    return <MobileMap habitats={habitats} urlParams={filters} showTrailers={showTrailers} onShowTrailer={onShowTrailer} />;
  };

  useEffect(() => {
    const { searchParams } = new URL(document.location);
    const urlParams = {
      partner: searchParams.get('p'),
      habitats: searchParams.getAll('h[]'),
      disabledHabitats: searchParams.getAll('dh[]'),
      freeHabitat: searchParams.get('fh'),
      callToAction: searchParams.get('cta'),
      freeCallToAction: searchParams.get('fcta'),
    };
    setFilters(urlParams);
  }, []);

  return (
    <div className={clsx(style.mapView, { [style.embed]: embed })}>
      {!isSmallScreen && (
        <DesktopMap habitats={habitats} urlParams={filters} showTrailers={showTrailers} onShowTrailer={onShowTrailer} />
      )}
      {isSmallScreen && renderMobileMap()}

      {trailer.show && typeof window !== 'undefined' && (
        <Suspense>
          <ShareModal
            open={trailer.show}
            data={trailer.data}
            onClose={() => setTrailer(trailerInitialState)}
            mediaId={trailer.data._id}
            isDownloadAllowed={false}
            shouldLoadPubnub
            isTrailer
          />
        </Suspense>
      )}
    </div>
  );
};

export default memo(MapView);
